import { AuthRoute } from '@/system-modules/auth/v1/api/AuthRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'

export class ConfirmLoginRequestRoute extends AuthRoute<null, null> {
  constructor(private readonly uuid: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.POST
  }

  url(): string {
    return '/api/system/v1/auth/login-requests/' + this.uuid + '/confirm'
  }

  offline(): Promise<ApiResponse<null>> {
    return Promise.resolve(new ApiResponse({ success: true, data: null }))
  }
}
